import styles from './index.less';
import { FC } from 'react';
interface IBindButtonProps {
  type: 'proceed' | 'success';
  btnClick: () => void;
  backClick: () => void;
}

const BindButton: FC<IBindButtonProps> = (props) => {
  const { type, btnClick, backClick } = props;
  return (
    <div className={styles.container}>
      <div
        onClick={type === 'proceed' ? btnClick : backClick}
        className={styles.btn}
      >
        {type === 'proceed' ? '保存' : '返回'}
      </div>
    </div>
  );
};
export default BindButton;
